export default __webpack_public_path__ + "locales/fi/FilesSettings.json?hash=1d885ea26ee59ac7397f452a125b879e";